import React from 'react';


const Divider = ()=>{
    return(
        <div className='container divider mt-4'></div>
    );
}

export default Divider;